const messages = {
    uploadImg: 'Upload image',
    errorDisplayImg: 'Error displaying image',
    select: {
        otherOption: 'other option'
    },
    submitForm: 'Submit Form',
    cancel: 'Cancel'
};
export default messages;
